/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speechmatics_Target_Language_GermanInputs */

const en_speechmatics_target_language_german = /** @type {(inputs: Speechmatics_Target_Language_GermanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`German`)
};

const fr_speechmatics_target_language_german = /** @type {(inputs: Speechmatics_Target_Language_GermanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allemand`)
};

const de_speechmatics_target_language_german = /** @type {(inputs: Speechmatics_Target_Language_GermanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deutsch`)
};

const it_speechmatics_target_language_german = /** @type {(inputs: Speechmatics_Target_Language_GermanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tedesco`)
};

const ru_speechmatics_target_language_german = /** @type {(inputs: Speechmatics_Target_Language_GermanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`немецкий`)
};

const es_speechmatics_target_language_german = /** @type {(inputs: Speechmatics_Target_Language_GermanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alemán`)
};

const zh_cn2_speechmatics_target_language_german = /** @type {(inputs: Speechmatics_Target_Language_GermanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`德语`)
};

const ja_speechmatics_target_language_german = /** @type {(inputs: Speechmatics_Target_Language_GermanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ドイツ語`)
};

const hi_speechmatics_target_language_german = /** @type {(inputs: Speechmatics_Target_Language_GermanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`जर्मन`)
};

const pt_pt2_speechmatics_target_language_german = /** @type {(inputs: Speechmatics_Target_Language_GermanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alemão`)
};

/**
* | output |
* | --- |
* | "German" |
*
* @param {Speechmatics_Target_Language_GermanInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speechmatics_target_language_german = /** @type {((inputs?: Speechmatics_Target_Language_GermanInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speechmatics_Target_Language_GermanInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_speechmatics_target_language_german(inputs)
	if (locale === "de") return de_speechmatics_target_language_german(inputs)
	if (locale === "it") return it_speechmatics_target_language_german(inputs)
	if (locale === "ru") return ru_speechmatics_target_language_german(inputs)
	if (locale === "es") return es_speechmatics_target_language_german(inputs)
	if (locale === "zh-CN") return zh_cn2_speechmatics_target_language_german(inputs)
	if (locale === "ja") return ja_speechmatics_target_language_german(inputs)
	if (locale === "hi") return hi_speechmatics_target_language_german(inputs)
	if (locale === "pt-PT") return pt_pt2_speechmatics_target_language_german(inputs)
	return en_speechmatics_target_language_german(inputs)
});